import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

export const AuthShell = ({ pageTestId, title, subtitle, footer, children }) => (
    <div className="min-h-screen bg-obsidian text-white flex flex-col" data-testid={pageTestId}>
        <div className="grid-bg absolute inset-0 opacity-30 pointer-events-none" />
        <div className="relative flex-1 flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <Link to="/" className="font-display font-bold uppercase tracking-tight text-xl block mb-10 text-center">
                    SPCLIVE<span className="text-blaze">//</span>STUDIO
                </Link>
                <div className="border border-white/10 bg-surface p-8">
                    <h1 className="font-display font-bold uppercase text-2xl tracking-tight mb-1">{title}</h1>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-8">
                        {subtitle}
                    </p>
                    {children}
                </div>
                <p className="text-center mt-6 font-mono text-xs text-white/40">{footer}</p>
            </div>
        </div>
    </div>
);

export const AuthField = ({ label, testId, ...inputProps }) => (
    <div>
        <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50 block mb-2">
            {label}
        </label>
        <input
            {...inputProps}
            className="w-full bg-obsidian border border-white/10 text-white px-3 py-3 font-mono text-sm outline-none focus:border-electric transition-colors"
            data-testid={testId}
        />
    </div>
);

export const AuthErrorBanner = ({ error, testId }) => {
    if (!error) return null;
    return (
        <div className="border border-blaze/40 bg-blaze/10 px-3 py-2.5 font-mono text-xs text-white/90" data-testid={testId}>
            {error}
        </div>
    );
};

export const OrDivider = () => (
    <div className="flex items-center gap-3 my-6">
        <div className="h-px bg-white/10 flex-1" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">or</span>
        <div className="h-px bg-white/10 flex-1" />
    </div>
);

export const AuthSubmitButton = ({ busy, testId, children }) => (
    <button
        type="submit"
        disabled={busy}
        className="w-full bg-blaze hover:bg-blazeHover disabled:opacity-50 text-white font-mono uppercase text-[11px] tracking-[0.25em] py-3.5 flex items-center justify-center gap-2 transition-colors"
        data-testid={testId}
    >
        {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
        {children}
    </button>
);
